import Swal from 'sweetalert2';
import axios from 'axios';

export const getEventPin = async () => {
    let pin = localStorage.getItem('EVENT_CHECKIN_PIN');
    
    if (!pin) {
        const { value: enteredPin } = await Swal.fire({
            title: 'Enter Event PIN',
            input: 'password',
            inputLabel: 'Volunteer Passcode',
            inputPlaceholder: 'Enter your 4-6 digit PIN',
            allowOutsideClick: false,
            allowEscapeKey: false,
            inputValidator: (value) => {
                if (!value) {
                    return 'You need to write something!';
                }
            }
        });

        if (enteredPin) {
            pin = enteredPin;
            localStorage.setItem('EVENT_CHECKIN_PIN', pin);
        }
    }
    
    return pin;
};

export const clearEventPin = () => {
    localStorage.removeItem('EVENT_CHECKIN_PIN');
};

export const handlePinAuthError = async () => {
    clearEventPin();
    await Swal.fire('Unauthorized', 'Invalid Event PIN. Please try again.', 'error');
    window.location.reload();
};

// Gate a page on load rather than waiting for the first action: prompt, check the
// PIN against the server, and keep asking until it is accepted. A signed-in admin
// passes without being asked at all.
export const requireEventPin = async (verifyUrl) => {
    for (;;) {
        try {
            const cached = localStorage.getItem('EVENT_CHECKIN_PIN');
            await axios.get(verifyUrl, cached ? { headers: { 'X-Event-Pin': cached } } : undefined);
            return true;
        } catch (error) {
            if (error.response?.status !== 401) {
                // Network or server trouble: do not lock volunteers out over it.
                return true;
            }
        }

        clearEventPin();
        const pin = await getEventPin();
        if (!pin) {
            await Swal.fire('需要 PIN', '請輸入義工報到密碼才能使用此頁面。', 'warning');
        }
    }
};
